import Customers from 'modules/Admin/customers/Customers'

function CustomersPage() {
  return (
    <div data-testid="adminCustomersPage">
      <Customers />
    </div>
  )
}

export default CustomersPage
